var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeacher(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#F7EDE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.59 18.725H46.4125V38.105H17.59V18.725Z",
    fill: "url(#paint0_linear_926_1220)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8225 19.315V37.5175H18.1775V19.315H45.8225ZM47 18.1375H17V38.695H47V18.1375Z",
    fill: "url(#paint1_linear_926_1220)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.725 35.9625C40.4125 35.395 40.81 34.8175 41.49 34.1025C42.5675 32.9675 43.74 30.335 42.65 27.6625C42.6575 27.6475 42.435 27.1975 42.4425 27.1825L41.995 27.16C41.8525 27.14 36.93 27.13 32.0025 27.13C27.075 27.13 22.1525 27.14 22.01 27.16C22.01 27.16 21.3475 27.6475 21.3525 27.6625C20.265 30.335 21.435 32.965 22.5125 34.1025C23.19 34.8175 23.5875 35.395 23.2775 35.9625C22.975 36.515 22.075 36.595 22.075 36.595C22.075 36.595 22.2825 37.16 22.7825 37.465C23.245 37.7475 23.815 37.8125 24.2075 37.8225C24.2075 37.8225 25.745 39.95 29.765 39.95H34.24C38.26 39.95 39.7975 37.8225 39.7975 37.8225C40.19 37.8125 40.76 37.7475 41.2225 37.465C41.7225 37.16 41.93 36.595 41.93 36.595C41.93 36.595 41.0275 36.515 40.725 35.9625Z",
    fill: "#AB872F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9976 39.9475V37.5875L39.1401 37.0225L39.7901 37.8225C39.7901 37.8225 38.2526 39.95 34.2326 39.95L31.9976 39.9475Z",
    fill: "url(#paint2_radial_926_1220)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.775 36.79C38.705 35.165 41.0775 34.5575 41.0775 34.5575L41.08 34.56C40.6675 35.0725 40.48 35.52 40.7225 35.9625C41.025 36.515 41.925 36.595 41.925 36.595C41.925 36.595 40.6975 37.685 39.775 36.79Z",
    fill: "url(#paint3_radial_926_1220)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6549 27.6625C43.7174 30.25 42.5999 32.915 41.5524 34.04C41.4099 34.195 40.7999 34.7925 40.6599 35.27C40.6599 35.27 38.2749 31.9425 37.5624 29.9875C37.4199 29.5925 37.2874 29.1875 37.2699 28.7675C37.2574 28.4525 37.3049 28.0775 37.4874 27.81C37.7099 27.4825 42.5274 27.385 42.5274 27.385C42.5274 27.3875 42.6549 27.6625 42.6549 27.6625Z",
    fill: "url(#paint4_radial_926_1220)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.35 27.6624C20.29 30.2499 21.4075 32.9149 22.4525 34.0374C22.5975 34.1924 23.205 34.7899 23.345 35.2674C23.345 35.2674 25.73 31.9399 26.4425 29.9849C26.5875 29.5899 26.7175 29.1849 26.735 28.7649C26.7475 28.4499 26.7 28.0749 26.5175 27.8074C26.295 27.4799 26.035 27.5674 25.6575 27.5674C24.9375 27.5674 21.785 27.3824 21.54 27.3824C21.5425 27.3874 21.35 27.6624 21.35 27.6624Z",
    fill: "url(#paint5_radial_926_1220)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0075 39.9475V37.5875L24.865 37.0225L24.215 37.8225C24.215 37.8225 25.7525 39.95 29.7725 39.95L32.0075 39.9475Z",
    fill: "url(#paint6_radial_926_1220)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.23 36.79C25.3 35.165 22.9275 34.5575 22.9275 34.5575L22.925 34.56C23.3375 35.0725 23.525 35.52 23.2825 35.9625C22.98 36.515 22.08 36.595 22.08 36.595C22.08 36.595 23.3075 37.685 24.23 36.79Z",
    fill: "url(#paint7_radial_926_1220)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.625 46.1875C44.625 42.32 38.29 40.2975 32.035 40.2975H32C25.715 40.305 19.375 42.1275 19.375 46.1875V47H44.625V46.1875Z",
    fill: "url(#paint8_linear_926_1220)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32 39.0825H29.73V41.5775L31.995 42.1725L34.27 41.5775V39.0825H32Z",
    fill: "#C48E6A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19 46.1875V47H27.2225L27.555 40.24C22.88 40.93 19 42.7875 19 46.1875Z",
    fill: "url(#paint9_linear_926_1220)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4449 40.24L36.7749 47H44.9999V46.1875C44.9999 42.7875 41.1199 40.93 36.4449 40.24Z",
    fill: "url(#paint10_linear_926_1220)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5075 39.03L32.005 42.235L27.945 43.895L27.3425 40.26L29.5075 39.03Z",
    fill: "#66C0E8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4925 39.03L31.995 42.235L36.055 43.895L36.6575 40.26L34.4925 39.03Z",
    fill: "#66C0E8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2199 39.75C28.2199 39.75 27.9349 40.43 27.7349 41.25C27.3374 42.88 27.3124 45.2 27.3124 45.2C27.3124 45.2 25.5899 44.615 25.0524 43.1875C24.4174 41.5 25.4899 40.5725 25.4899 40.5725C25.4899 40.5725 25.7149 40.4775 26.6599 39.9575C27.6049 39.4375 28.2199 39.75 28.2199 39.75ZM35.7799 39.75C35.7799 39.75 36.0649 40.43 36.2649 41.25C36.6624 42.88 36.6874 45.2 36.6874 45.2C36.6874 45.2 38.4099 44.615 38.9474 43.1875C39.5824 41.5 38.5099 40.5725 38.5099 40.5725C38.5099 40.5725 38.2849 40.4775 37.3399 39.9575C36.3949 39.4375 35.7799 39.75 35.7799 39.75Z",
    fill: "#AF5214"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7799 28.6075H25.1174C23.6449 28.6075 22.4399 29.8925 22.4399 31.46C22.4399 33.0275 23.6449 34.3125 25.1174 34.3125H38.7799C40.2524 34.3125 41.4574 33.0275 41.4574 31.46C41.4574 29.8925 40.2524 28.6075 38.7799 28.6075Z",
    fill: "#C48E6A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9475 18.7675C27.5975 18.7675 23.5675 23.42 23.5675 30.1175C23.5675 36.7775 27.72 40.07 31.9475 40.07C36.175 40.07 40.3275 36.775 40.3275 30.115C40.3275 23.42 36.3 18.7675 31.9475 18.7675Z",
    fill: "#E0BB95"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.995 31.9775C28.6756 31.9775 29.2275 31.4067 29.2275 30.7025C29.2275 29.9983 28.6756 29.4275 27.995 29.4275C27.3143 29.4275 26.7625 29.9983 26.7625 30.7025C26.7625 31.4067 27.3143 31.9775 27.995 31.9775Z",
    fill: "#5D4037"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7824 31.9775C36.4631 31.9775 37.0149 31.4067 37.0149 30.7025C37.0149 29.9983 36.4631 29.4275 35.7824 29.4275C35.1017 29.4275 34.5499 29.9983 34.5499 30.7025C34.5499 31.4067 35.1017 31.9775 35.7824 31.9775Z",
    fill: "#5D4037"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8425 28.455C29.61 28.1475 29.075 27.7025 28.035 27.7025C26.995 27.7025 26.4575 28.15 26.2275 28.455C26.125 28.59 26.15 28.7475 26.2225 28.8425C26.2875 28.93 26.4825 29.0125 26.6975 28.94C26.9125 28.8675 27.3325 28.65 28.035 28.645C28.7375 28.65 29.1575 28.8675 29.3725 28.94C29.5875 29.0125 29.7825 28.9325 29.8475 28.8425C29.9175 28.7475 29.945 28.59 29.8425 28.455ZM37.59 28.455C37.3575 28.1475 36.8225 27.7025 35.7825 27.7025C34.7425 27.7025 34.205 28.15 33.975 28.455C33.8725 28.59 33.8975 28.7475 33.97 28.8425C34.035 28.93 34.23 29.0125 34.445 28.94C34.66 28.8675 35.08 28.65 35.7825 28.645C36.485 28.65 36.905 28.8675 37.12 28.94C37.335 29.0125 37.53 28.9325 37.595 28.8425C37.6675 28.7475 37.6925 28.59 37.59 28.455Z",
    fill: "#AB872F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9125 33.015C32.885 33.005 32.86 32.9975 32.8325 32.995H31.0625C31.035 32.9975 31.0075 33.005 30.9825 33.015C30.8225 33.08 30.735 33.245 30.81 33.4225C30.885 33.6 31.2375 34.095 31.9475 34.095C32.6575 34.095 33.01 33.5975 33.085 33.4225C33.1625 33.245 33.0725 33.08 32.9125 33.015Z",
    fill: "#C48E6A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M34.08 35.035C33.285 35.5075 30.6725 35.5075 29.8775 35.035C29.42 34.7625 28.9525 35.18 29.1425 35.595C29.33 36.0025 30.7525 36.95 31.985 36.95C33.2175 36.95 34.6225 36.0025 34.81 35.595C35 35.18 34.5375 34.7625 34.08 35.035Z",
    fill: "#6D4C41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4575 29.2325C39.44 28.935 39.4275 28.905 39.035 28.78C38.7275 28.6825 37.0475 28.545 35.7825 28.615C35.6925 28.62 35.605 28.625 35.5225 28.6325C34.375 28.73 32.9975 29.1925 31.9625 29.2175C31.5225 29.2275 29.71 28.7525 28.4275 28.6525C28.345 28.6475 28.2625 28.64 28.1775 28.6375C26.91 28.5725 25.2225 28.72 24.915 28.82C24.5225 28.9475 24.51 28.9775 24.495 29.275C24.4775 29.5725 24.5275 29.825 24.76 29.9025C25.0775 30.0075 25.08 30.4025 25.2925 31.5375C25.485 32.5725 25.9475 33.39 27.935 33.5325C28.02 33.5375 28.1 33.5425 28.18 33.5425C29.9375 33.5675 30.5425 32.41 30.7425 32.025C31.115 31.31 30.9975 30.325 31.9825 30.3225C32.965 30.32 32.8725 31.2875 33.25 32C33.4525 32.3825 34.0425 33.545 35.785 33.52C35.87 33.52 35.9575 33.515 36.0475 33.5075C38.0325 33.3525 38.4925 32.5325 38.6775 31.4975C38.8825 30.36 38.885 29.9625 39.2 29.8575C39.4275 29.7825 39.4775 29.53 39.4575 29.2325ZM29.32 33.0425C29.015 33.185 28.6075 33.2575 28.1775 33.2575C27.28 33.255 26.285 32.94 25.925 32.305C25.415 31.4 25.2825 29.57 25.9325 29.1875C26.2175 29.02 27.18 28.905 28.175 28.9475C29.2075 28.9925 30.275 29.2075 30.66 29.7125C31.2975 30.545 30.285 32.5875 29.32 33.0425ZM38.045 32.2675C37.6875 32.9075 36.685 33.23 35.7825 33.2325C35.3575 33.235 34.955 33.165 34.655 33.025C33.6875 32.575 32.6625 30.54 33.2925 29.7025C33.675 29.1925 34.7475 28.9725 35.7825 28.9225C36.775 28.875 37.735 28.985 38.0175 29.15C38.67 29.53 38.55 31.36 38.045 32.2675Z",
    fill: "#212121",
    stroke: "#212121",
    strokeWidth: 0.55,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M41.4176 46.4025L41.5601 45.8525L41.5626 45.84L42.0451 43.94L40.3201 43.445L31.5901 40.9375C31.5776 40.935 31.5676 40.935 31.5576 40.93C31.1672 40.8273 30.7521 40.8814 30.4011 41.081C30.0502 41.2805 29.7914 41.6095 29.6801 41.9975L28.2426 47H41.2476L41.4176 46.4025Z",
    fill: "url(#paint11_linear_926_1220)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4375 43.97C42.51 43.7175 42.365 43.455 42.1125 43.385L32.44 40.61C32.0458 40.4973 31.6231 40.5457 31.2645 40.7444C30.9059 40.9431 30.6409 41.276 30.5275 41.67L29 47H41.57L42.4375 43.97Z",
    fill: "#424242"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M42.27 46.0775C42.3575 45.7725 42.175 45.4525 41.865 45.365L31.485 42.39C30.3525 42.065 30.155 42.9775 29.8375 44.085L29 47H42.005L42.27 46.0775Z",
    fill: "url(#paint12_linear_926_1220)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M31.815 40.5601C31.5163 40.5988 31.2355 40.724 31.0072 40.9203C30.7789 41.1167 30.613 41.3756 30.53 41.6651L29 47.0001H29.9675L31.815 40.5601Z",
    fill: "url(#paint13_linear_926_1220)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32.0824 41.3926C32.1274 41.3926 32.1774 41.3976 32.2299 41.4101L41.5424 44.0851L41.4649 44.3551C38.5174 43.5326 32.8924 41.9501 31.7299 41.5651C31.7899 41.4826 31.9074 41.3926 32.0824 41.3926ZM32.0824 40.5601C30.9524 40.5601 30.3874 41.9526 31.3024 42.2951C32.3099 42.6701 42.0349 45.3751 42.0349 45.3751L42.4299 43.9951C42.5074 43.7301 42.3824 43.4601 42.1524 43.3951L32.4424 40.6051C32.3174 40.5751 32.1974 40.5601 32.0824 40.5601Z",
    fill: "#424242"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8425 44.03L31.8925 41.175C31.6225 41.0975 31.3275 41.29 31.2375 41.6025L31.2225 41.6575C31.1325 41.97 31.28 42.29 31.55 42.3675L41.5 45.2225C41.5 45.2225 41.415 45.015 41.5175 44.6475C41.62 44.2775 41.8425 44.03 41.8425 44.03Z",
    fill: "url(#paint14_linear_926_1220)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0175 22.2774C41.4075 21.3549 40.04 20.1174 38.8125 20.0349C38.615 18.8549 37.3525 17.8549 36.13 17.4674C32.8225 16.4199 30.67 17.5949 29.515 18.2249C29.275 18.3549 27.7225 19.2174 26.6375 18.5999C25.9575 18.2124 25.97 17.1649 25.97 17.1649C25.97 17.1649 23.84 17.9774 24.5675 20.2399C23.835 20.2699 22.875 20.5799 22.3675 21.6074C21.7625 22.8324 21.9775 23.8549 22.1525 24.3449C21.5225 24.8799 20.73 26.0174 21.2725 27.4949C21.6825 28.6074 23.315 29.1199 23.315 29.1199C23.2 31.1224 23.5725 32.3549 23.77 32.8524C23.805 32.9399 23.9275 32.9324 23.95 32.8424C24.1975 31.8499 25.0425 28.3924 24.9575 27.7899C24.9575 27.7899 27.795 27.2274 30.5 25.2349C31.05 24.8299 31.6475 24.4849 32.2825 24.2324C35.68 22.8799 36.39 25.1874 36.39 25.1874C36.39 25.1874 38.745 24.7349 39.455 28.0049C39.7225 29.2299 39.9025 31.1924 40.055 32.5649C40.065 32.6624 40.1975 32.6824 40.235 32.5924C40.4725 32.0474 40.9475 30.9674 41.06 29.8649C41.1 29.4774 42.145 28.9649 42.595 27.2999C43.1975 25.0799 42.46 22.9449 42.0175 22.2774Z",
    fill: "#AB872F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M41.055 29.875C41.095 29.4875 42.14 28.975 42.59 27.31C42.6375 27.1325 42.6775 26.9525 42.715 26.7725C43.08 24.75 42.425 22.8925 42.0175 22.2775C41.4525 21.425 40.2425 20.305 39.095 20.075C38.995 20.0625 38.8975 20.05 38.805 20.045C38.805 20.045 38.8875 20.5825 38.67 21.01C38.39 21.565 37.8175 21.6975 37.8175 21.6975C40.81 24.6925 40.5975 27.1975 41.055 29.875Z",
    fill: "url(#paint15_radial_926_1220)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2374 17.8475C29.9624 17.98 29.7224 18.1125 29.5124 18.225C29.2724 18.355 27.7199 19.2175 26.6349 18.6C25.9674 18.22 25.9674 17.205 25.9674 17.17C25.6599 17.5625 24.7299 20.365 27.4499 20.5525C28.6224 20.6325 29.3449 19.61 29.7749 18.745C29.9299 18.43 30.1724 17.97 30.2374 17.8475Z",
    fill: "url(#paint16_radial_926_1220)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M35.79 17.3675C37.62 17.8625 38.5125 18.795 38.81 20.0375C38.8975 20.4025 39.0025 23.8075 32.5025 19.9375C30.085 18.4975 30.745 17.5975 31.0275 17.495C32.1325 17.095 33.74 16.8125 35.79 17.3675Z",
    fill: "url(#paint17_radial_926_1220)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M25.96 17.17C25.9575 17.1725 25.9525 17.1725 25.945 17.1775H25.9425C25.71 17.275 23.8825 18.1225 24.565 20.24L26.51 20.5525C24.7875 18.8075 25.9675 17.165 25.9675 17.165C25.9675 17.165 25.9625 17.1675 25.96 17.17Z",
    fill: "url(#paint18_radial_926_1220)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7675 20.4325L24.565 20.24C24.5175 20.24 24.3575 20.255 24.27 20.2675C23.5925 20.3625 22.795 20.7125 22.3625 21.6075C21.8975 22.5725 21.91 23.4 22.0375 23.9525C22.075 24.1375 22.15 24.3475 22.15 24.3475C22.15 24.3475 22.745 23.7825 24.1625 23.745L25.7675 20.4325Z",
    fill: "url(#paint19_radial_926_1220)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0925 24.395C21.5 24.92 20.7025 26.0925 21.29 27.5475C21.7325 28.645 23.3125 29.12 23.3125 29.12C23.3125 29.125 23.6275 29.22 23.79 29.22L24.16 23.745C23.4025 23.745 22.675 23.9725 22.205 24.3C22.2125 24.3075 22.09 24.3875 22.0925 24.395Z",
    fill: "url(#paint20_radial_926_1220)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_926_1220",
    x1: 31.9997,
    y1: 18.8487,
    x2: 31.9997,
    y2: 38.1222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26A69A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00796B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_926_1220",
    x1: 31.9998,
    y1: 18.1362,
    x2: 31.9998,
    y2: 38.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D6E63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#795548"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_926_1220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.6458 36.5376) scale(5.85475 2.87585)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#BFA055",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA055"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_926_1220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.4127 35.6664) rotate(154.924) scale(1.73016 1.28353)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#BFA055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA055",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_926_1220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.9286 30.7729) rotate(-94.2783) scale(7.59965 6.33382)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#BFA055",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA055"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_926_1220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.0771 30.7727) rotate(-85.7217) scale(7.59965 6.33382)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#BFA055",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA055"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_926_1220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.3597 36.5376) rotate(180) scale(5.85475 2.87585)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#BFA055",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA055"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_926_1220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.5932 35.6665) rotate(25.0761) scale(1.73016 1.28353)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#BFA055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA055",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_926_1220",
    x1: 32,
    y1: 41.523,
    x2: 32,
    y2: 45.2655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81D4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_926_1220",
    x1: 23.2783,
    y1: 40.711,
    x2: 23.2783,
    y2: 46.7575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341,
    stopColor: "#FF9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#FF7100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_926_1220",
    x1: 40.7219,
    y1: 40.6412,
    x2: 40.7219,
    y2: 46.7982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341,
    stopColor: "#FF9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#FF7100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_926_1220",
    x1: 35.8923,
    y1: 42.3218,
    x2: 35.2366,
    y2: 45.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#212121",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_926_1220",
    x1: 36.46,
    y1: 43.7255,
    x2: 35.9673,
    y2: 45.3785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E53935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_926_1220",
    x1: 30.6012,
    y1: 43.2218,
    x2: 31.067,
    y2: 41.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424242"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_926_1220",
    x1: 31.2309,
    y1: 41.6293,
    x2: 41.6706,
    y2: 44.6253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.987,
    stopColor: "#F8F8F7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_926_1220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.5042 26.7629) rotate(72.0851) scale(8.90812 6.60961)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#BFA055",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA055"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_926_1220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.8202 17.0504) rotate(28.2026) scale(2.3358 2.76957)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#BFA055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA055",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_926_1220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.0404 21.2923) rotate(-157.19) scale(7.30489 4.10538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#BFA055",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA055"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_926_1220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.8822 19.1813) scale(2.14375 2.62245)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#BFA055",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA055"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_926_1220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.587 22.9653) rotate(-164.942) scale(4.0209 3.76283)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#BFA055",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA055"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_926_1220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.6341 26.8477) rotate(7.83355) scale(4.22164 5.93209)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#BFA055",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA055"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacher);
export default __webpack_public_path__ + "static/media/teacher.844ce4108457d2faf498f780462812e7.svg";
export { ForwardRef as ReactComponent };